// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .default-cursor[data-v-21b5d7e4] {\n  cursor: auto !important;\n}\n[dir] .cursor-pointer[data-v-21b5d7e4] {\n  cursor: pointer !important;\n}", ""]);
// Exports
module.exports = exports;
